export enum FieldName {
    ID = 'id',
}

export enum SurveyCommonFilter {
    Date = 'R4ESurvey3.survey.date',
    ObjectModel = 'object_model',
}

export enum SurveyResultFilter {
    Id = 'R4ESurvey3.survey.id',
    Date = 'R4ESurvey3.survey.date',
    FinalDate = 'R4ESurvey3.survey.finalDate',
    TemplateID = 'R4ESurvey3.survey.template_id',
    ResultStatus = 'R4ESurvey3.survey.result_status',
    Categories = 'R4ESurvey3.survey.categories',
    Quality = 'R4ESurvey3.survey.quality',
    Flagged = 'R4ESurvey3.survey.flagged',
    /** e.g. Responded vs Unresponded */
    ResponseStatus = 'R4ESurvey3.survey.responded',
    Read = 'R4ESurvey3.survey.read',
    Syndicated = 'R4ESurvey3.survey.syndicated',
    /** e.g. Published vs Unpublished */
    PublishStatus = 'R4ESurvey3.survey.publish',
    Sentiment = 'R4ESurvey3.survey.sentiment',
    AttributedReviews = 'R4ESurvey3.survey.attributed_reviews',
    EmployeeAttributions = 'R4ESurvey3.survey.employee_attributions',
    CommentText = 'R4ESurvey3.survey.comment_text',
    WordCount = 'R4ESurvey3.survey.word_count',
}

export enum SurveyTemplateFilter {
    TemplateId = 'R4ESurvey3.survey.template_id',
    TemplateStatus = 'R4ESurvey3.survey.template_status',
}
